/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useMemo, useContext } from "react";
import PropTypes from "prop-types";
import ButtonBar from "../ButtonBar";
import { DataContext } from "../../context/DataContext";
import JudgeDay from "./JudgeDay";
import JudgeTime from "./JudgeTime";
import { JUDGE_BUTTON_SCHEMA } from "../../utils/constants";

const changeDisplay = ({ judgeDisplay, selectedJudgeData, year }) => {
  const ENUM = {
    days: <JudgeDay selectedJudgeData={selectedJudgeData} year={year} />,
    time: <JudgeTime selectedJudgeData={selectedJudgeData} year={year} />,
  };
  return ENUM[judgeDisplay];
};

const withData = (WrappedComponent) => {
  const WithData = (props) => {
    const { judgesData, selection, year } = useContext(DataContext);
    if (selection.type === "judge") {
      return (
        <WrappedComponent
          {...props}
          year={year}
          judgesData={judgesData}
          selection={selection}
          foo
        />
      );
    }
    return null;
  };

  const wrappedComponentName =
    WrappedComponent.displayName || WrappedComponent.name || "Component";

  WithData.displayName = `withFoo(${wrappedComponentName})`;
  return WithData;
};

const Judge = ({ judgesData, selection, year }) => {
  const [judgeDisplay, setJudgeDisplay] = useState("days");
  const selectedJudgeData = useMemo(
    () => judgesData.find((judge) => judge.id === selection.id),
    [judgesData, selection]
  );
  const { name, court, county } = selectedJudgeData;

  return (
    <div className="panel__judge">
      <div className="panel__judge-name-container">
        <h3 className="panel__judge-name">{name}</h3>
        <h3>
          {county} (District {court})
        </h3>
      </div>
      <ButtonBar
        schema={JUDGE_BUTTON_SCHEMA}
        handleClick={setJudgeDisplay}
        active={judgeDisplay}
      />
      {changeDisplay({ judgeDisplay, selectedJudgeData, year })}
    </div>
  );
};

Judge.propTypes = {
  judgesData: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  selection: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    county: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  year: PropTypes.number.isRequired,
};

export default withData(Judge);
